import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Box, Typography } from '@material-ui/core'
import { Loader, DisplayMessage, Breadcrumb } from '../../Components'
import { TableOutline, Cards, OutlinedButton, Toggle } from '../../elements'
import { tableHeadings, getProgramToggleOptions, ONGOING, ALLPROGRAMS } from './constant'
import { useStyles } from './style'
import { forwardTo } from '../../utils/helper'
import { programService } from '../../Services'
import { SORTORDER } from '../../utils/constants'
import { SUCCESS } from '../../utils/messageTypes'

function Programs(props) {
  const classes = useStyles()
  const [selectedToggle, setToggleValue] = useState(ONGOING)
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [accountId, setAccountId] = useState('')
  const [loading, setLoading] = useState(false)
  const [programList, setProgramList] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [sortBy, setSortBy] = useState('')
  const [headings, setHeadings] = useState(tableHeadings(classes))
  const [onGoingCount, setOngoingCount] = useState(0)
  const [showMessage, setShowMessage] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState(SUCCESS)
  const [allProgramsCount, setAllProgramsCount] = useState(0)
  const [order, setOrder] = useState(SORTORDER.ASC)

  useEffect(() => {
    if (selectedToggle === ONGOING) {
      setHeadings(tableHeadings(classes))
    } else {
      const columns = tableHeadings(classes)
      columns.push({
        id: 'status',
        header: 'STATUS',
        className: `${classes.tableHeading} ${classes.status}`
      })
      setHeadings(columns)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedToggle])

  useEffect(() => {
    setShowMessage(_.get(props.location, 'showMessage', false))
    setMessage(_.get(props.location, 'message', ''))
    setMessageType(_.get(props.location, 'messageType', SUCCESS))
  }, [props.location])

  useEffect(() => {
    const currentAccountId = _.get(props.currentUser, 'account_id', '')
    setAccountId(currentAccountId)
  }, [props.currentUser])

  useEffect(() => {
    if (accountId) {
      getAllPrograms(page, rowsPerPage, sortBy, ONGOING, order)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId])

  const getAllPrograms = (pageNum, pageSize, sortColBy, selectedToggleVal, sortOrder) => {
    setLoading(true)
    programService
      .getAllPrograms(accountId, {
        page: pageNum - 1,
        size: pageSize,
        sortBy: sortColBy,
        isActive: selectedToggleVal === ONGOING || '',
        sortOrder
      })
      .then((response) => {
        const programs = _.get(response, 'programs', [])
        setTotalCount(_.get(response, 'total_count', 0))
        setProgramList(programs)
        setLoading(false)

        if (selectedToggleVal === ONGOING) {
          setOngoingCount(_.get(response, 'total_count', 0))
          setAllProgramsCount(_.get(response, 'total_program_count', 0))
        }
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
    getAllPrograms(1, value, sortBy, selectedToggle, order)
  }

  const handlePageChange = (newPage) => {
    setPage(newPage)
    getAllPrograms(newPage, rowsPerPage, sortBy, selectedToggle, order)
  }

  const handleSortData = (sortedObj) => {
    const modifiedObj = _.cloneDeep(headings)
    modifiedObj.forEach((obj, index) => {
      if (obj.id === sortedObj.id && obj.isSortable) {
        modifiedObj[index].sortOrder =
          obj.sortOrder === SORTORDER.ASC ? SORTORDER.DESC : SORTORDER.ASC
      } else {
        modifiedObj[index].sortOrder = SORTORDER.ASC
      }
    })
    const selectedObj = modifiedObj.find((obj) => sortedObj.id === obj.id)
    const selectedTypeAsc = selectedObj.sortOrder === SORTORDER.ASC ? SORTORDER.ASC : SORTORDER.DESC
    setOrder(selectedTypeAsc)
    setPage(1)
    setSortBy(sortedObj.id)
    getAllPrograms(1, rowsPerPage, selectedObj.id, selectedToggle, selectedTypeAsc)
    setHeadings(modifiedObj)
  }

  const getProgramData = () => {
    const programDetails = []
    programList.forEach((obj) => {
      const programObject = _.get(obj, 'program_object', {})
      let tableObj = [
        {
          id: 'programName',
          value: _.get(programObject, 'program_name_admin_ui', ''),
          programId: _.get(obj, 'program_id', ''),
          handleClick: (selected) =>
            props.history.push({
              pathname: `/programs/${_.get(selected, 'programId', '')}`
            }),
          className: classes.programName
        },
        {
          id: 'accountName',
          value: _.get(obj, 'account_name', ''),
        },
        {
          id: 'systemsEnrolled',
          value: _.get(obj, 'systems_enrolled', ''),
          className: `${classes.tableRightAlign} ${classes.marginRight} ${classes.systemsEnrolled}`
        },
      ]

      if (selectedToggle !== ONGOING) {
        tableObj.push({
          id: 'status',
          value: _.get(obj.program_object, 'is_active', false) ? 'Active' : 'Inactive',
          className: `${classes.tableRightAlign} ${classes.tabelStatusCol}`
        })
      }
      programDetails.push(tableObj)
    })

    return programDetails
  }

  const handleCreateNewPropgram = () => {
    forwardTo('/program-request')
  }

  const handleToggleChange = (value) => {
    setToggleValue(value)
    setPage(1)
    getAllPrograms(1, rowsPerPage, sortBy, value, order)
  }

  const renderProgramContent = () => {
    const tableData = getProgramData()
    return (
      <Box>
        <Toggle
          list={getProgramToggleOptions(onGoingCount, allProgramsCount)}
          selected={selectedToggle}
          onChange={handleToggleChange}
        />
        <br />
        <br />
        <TableOutline
          tableHeadings={headings}
          tableData={tableData}
          totalElement={totalCount}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handlePageChange}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          pagination
          handleSortData={handleSortData}
          loading={loading}
        />
      </Box>
    )
  }

  return (
    <Box>
      <Breadcrumb value={[{ 'Home': '/' }, { 'Programs': '' }]} />
      <Box className={classes.programsHeaderWrapper}>
        <Typography className={classes.title}>Programs</Typography>
        {!props.isSuperAdmin && props.isAdmin && <OutlinedButton
          label="create new program"
          onClick={handleCreateNewPropgram}
        />}
      </Box>
      <Cards
        className={classes.cardWrapper}
        children={renderProgramContent()}
      />
      <Loader loading={loading} />
      <DisplayMessage open={showMessage} message={message} messageType={messageType} handleClose={() => setShowMessage(false)} />
    </Box >
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin, isAdmin } = auth
  return { currentUser, isSuperAdmin, isAdmin }
}

export default connect(mapStateToProps, {})(Programs)
